<div class="profile-container">
  @if(isEditing){
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-6">
      <app-edit-profile [user]="user" (saveProfile)="onSaveProfile($event)"
        (cancelEdit)="isEditing = false"></app-edit-profile>
    </div>
  </div>
  } @else {
  <!-- Header avec gradient -->
  <div class="modern-header">
    <div class="container">
      <div class="profile-hero">
        <div class="avatar-section">
          @if(user && user.avatar){
          <img [src]="apiUrl+user.avatar" alt="Avatar" class="modern-avatar">
          } @else {
          <img src="/images/user/avatar.png" alt="Avatar" class="modern-avatar">
          }
        </div>
        <div class="user-info">
          <h1 class="user-name">{{ user?.firstName + " " + user?.lastName }}</h1>
          <p class="user-type">
            <i class="bi bi-person-badge me-2"></i>{{ user?.userType }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Contenu principal -->
  <div class="container profile-content">
    <div class="row g-4">
      <!-- Colonne gauche - Informations de contact -->
      <div class="col-lg-4">
        <div class="info-card">
          <h3 class="card-title">
            <i class="bi bi-person-lines-fill me-2"></i>Informations de contact
          </h3>
          <div class="info-list">
            <div class="info-item">
              <div class="info-icon">
                <i class="bi bi-envelope"></i>
              </div>
              <div class="info-content">
                <label>Email</label>
                <p>{{user?.email}}</p>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="bi bi-telephone"></i>
              </div>
              <div class="info-content">
                <label>Téléphone</label>
                <p>{{user?.phoneNumber}}</p>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="bi bi-geo-alt"></i>
              </div>
              <div class="info-content">
                <label>Adresse</label>
                <p>{{user?.address | address}}</p>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="action-buttons">
            <button type="button" class="btn-modern btn-primary" (click)="isEditing = true">
              <i class="bi bi-pencil me-2"></i>Éditer mon profil
            </button>
            <button type="button" class="btn-modern btn-outline" (click)="onChangePassword()">
              <i class="bi bi-lock me-2"></i>Changer mot de passe
            </button>
            <button type="button" class="btn-modern btn-outline">
              <a routerLink="/dashboard" class="text-decoration-none text-reset">
                <i class="bi bi-speedometer2 me-2"></i>Mon tableau de bord
              </a>
            </button>
          </div>
        </div>
      </div>

      <!-- Colonne droite - Abonnement et Favoris -->
      <div class="col-lg-8">
        <!-- Carte Abonnement -->
        <div class="info-card subscription-card">
          <div class="card-header-modern">
            <h3 class="card-title">
              <i class="bi bi-star-fill me-2"></i>Mon abonnement
            </h3>
            <span class="badge-active">{{ user?.userPlan?.status }}</span>
          </div>
          <div class="subscription-content">
            <div class="plan-header">
              <div class="plan-name">{{ user?.userPlan?.planName }}</div>
              <div class="plan-price">{{ user?.userPlan?.amount }} €<span>/an</span></div>
            </div>
            <div class="plan-details">
              <div class="detail-item">
                <i class="bi bi-calendar-check"></i>
                <div>
                  <label>Date de début</label>
                  <p>{{ user?.userPlan?.startDate | date:'dd MMMM yyyy' }}</p>
                </div>
              </div>
              <div class="detail-item">
                <i class="bi bi-calendar-event"></i>
                <div>
                  <label>Date de fin</label>
                  <p>{{ user?.userPlan?.endDate | date:'dd MMMM yyyy' }}</p>
                </div>
              </div>
            </div>
          </div>
          @if(user?.userPlan?.planName !== 'premium') {
          <button class="btn-modern btn-primary mt-4" (click)="showUpgradeModal()">
            <i class="bi bi-arrow-up-circle me-2"></i>Améliorer mon abonnement
          </button>
          }
        </div>

        <!-- Carte Favoris -->
        <div class="info-card favorites-card">
          <div class="card-header-modern">
            <h3 class="card-title">
              <i class="bi bi-heart-fill me-2"></i>Mes favoris
            </h3>
            <span class="badge-count">{{user?.favorites?.length}}</span>
          </div>
          <div class="favorites-content">
            <p class="text-muted mb-3">Accédez rapidement à vos éléments favoris</p>
            <a routerLink="/favorites" class="btn-modern btn-primary w-100">
              <i class="bi bi-arrow-right-circle me-2"></i>Voir tous mes favoris
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>

<!-- Modal d'upgrade -->
<div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="upgradeModalLabel">
          <i class="bi bi-trophy-fill me-2"></i>Choisir votre abonnement
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <!-- Plan Basic -->
          <div class="col-md-6">
            <div class="plan-card basic-plan" [class.disabled]="user?.userPlan?.planName === 'basic'"
              [class.selected]="selectedPlan === 'basic' && user?.userPlan?.planName !== 'basic'"
              (click)="selectPlan('basic')">
              <h5>Basic</h5>
              <p class="price">100€/an</p>
              <p class="sub-price">(≈ 8,33€/mois)</p>
              <ul class="features-list">
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Visibilité standard</li>
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Limite de 1 société</li>
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Facturation annuelle</li>
              </ul>
              @if(user?.userPlan?.planName === 'basic') {
              <div class="current-plan-badge">
                <i class="bi bi-check-circle-fill me-1"></i>Plan actuel
              </div>
              }
            </div>
          </div>

          <!-- Plan Premium -->
          <div class="col-md-6">
            <div class="plan-card premium-plan" [class.selected]="selectedPlan === 'premium'"
              (click)="selectPlan('premium')">
              <div class="recommended-badge">
                <i class="bi bi-star-fill me-1"></i>Recommandé
              </div>
              <h5>Premium</h5>
              <p class="price">150€/an</p>
              <p class="sub-price">(≈ 12,50€/mois)</p>
              <ul class="features-list">
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Visibilité boostée</li>
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Limite de 5 sociétés</li>
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Support prioritaire</li>
                <li><i class="bi bi-check-circle-fill text-success me-2"></i>Facturation annuelle</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
        <button type="button" class="btn btn-primary" (click)="confirmUpgrade()"
          [disabled]="isProcessing || !selectedPlan || selectedPlan === user?.userPlan?.planName">
          @if(!isProcessing){
          <span>
            <i class="bi bi-credit-card me-2"></i>Confirmer et payer
          </span>
          } @else {
          <span>
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Redirection...
          </span>
          }
        </button>
      </div>
    </div>
  </div>
</div>